import { createContext } from 'react';
export var defaultWixSDKContext = {
    Wix: null,
};
export var defaultEditorSDKContext = {
    editorSDK: null,
    editorSDKConfig: null,
};
export var WixSDKContext = createContext(defaultWixSDKContext);
export var EditorSDKContext = createContext(defaultEditorSDKContext);
//# sourceMappingURL=SDKContext.js.map